const departments = [
  { value: "All", label: "All" },
  { value: "Behavioral Health Services", label: "Behavioral Health Services" },
  { value: "Native Challenge", label: "Native Challenge" },
  { value: "Nutrition", label: "Nutrition" },
  { value: "Medical", label: "Medical" },
];

export default departments;
